import { render, staticRenderFns } from "./DeFi.vue?vue&type=template&id=7e66e114&"
import script from "./DeFi.vue?vue&type=script&lang=js&"
export * from "./DeFi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports